module.exports = __webpack_public_path__ + "static/media/sea-logo.f493301b.png";